/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import { theme } from '@getgo/chameleon-chakra-ui';
import { Dict } from '@chakra-ui/utils';

export const GoToMeetingTheme: Dict<any> = {
  ...theme,
  config: {
    useSystemColorMode: false,
    initialColorMode: 'light',
  },
  styles: {
    ...theme.styles,
    global: {
      ...theme.styles.global,
      'html, body, #root, #app, #scrollcushion': {
        height: '100%',
        width: '100%',
        margin: '0',
        padding: '0 !important',
        minWidth: 0,
      },
      html: {
        border: 'none',
        boxSizing: 'content-box',
      },
      '#app': {
        color: 'white',
        overflow: 'auto',
        whiteSpace: 'pre-line',
        fontFamily: 'lato-regular, sans-serif',
      },
      a: {
        fontWeight: 'bold',
      },
      h1: {
        fontSize: '2rem',
        fontWeight: 'bold',
      },
      h2: {
        fontSize: '1.5rem',
        fontWeight: 'bold',
      },
      h3: {
        fontSize: '1.17rem',
        fontWeight: 'bold',
      },
      h4: {
        fontSize: '1rem',
        fontWeight: 'bold',
      },
      h5: {
        fontSize: '0.83rem',
        fontWeight: 'bold',
      },
      h6: {
        fontSize: '0.67rem',
        fontWeight: 'bold',
      },
      '*::-ms-backdrop, #app': {
        height: '421px',
        minHeight: '100%',
      },
      '*::-ms-backdrop, #footer': {
        bottom: 0,
        position: 'absolute',
      },
      '*::-ms-backdrop, #checkmark': {
        height: '22px',
        width: '22px',
      },
      '*::-ms-backdrop, #calloutContainer': {
        display: 'block',
        padding: '2vh 5vh 3vh',
        maxWidth: '517px',
      },
      '*::-ms-backdrop, #selfHelpBox': {
        paddingTop: '15rem',
      },
    },
  },
};
